// extracted by mini-css-extract-plugin
export var cardIcon = "_7d-5";
export var cardIconUnframed = "_7d-9";
export var checkboxCard = "_7d-0";
export var checkboxCardSelected = "_7d-4";
export var disabled = "_7d-2";
export var interactive = "_7d-1";
export var outerBorder = "_7d-3";
export var spacerMedium = "_7d-8";
export var spacerSmall = "_7d-7";
export var spacerXsmall = "_7d-6";